import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetManagementOrganizationCentersAction} from '../action';

function* execute({payload}: GetManagementOrganizationCentersAction): SagaIterator {
    const response = yield* call(Api.findAllCentersByOrganizationIdForPrincipal, payload);

    if (response.isSuccess) {
        yield* put(adminAction.setManagementOrganizationCenters(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('loadCenters')));
    }
}
/** Runs the admin saga that loads center options for organization management. */
export function* getManagementOrganizationCentersSaga(): SagaIterator {
    yield takeLatestF('admin/GET_MANAGEMENT_ORGANIZATION_CENTERS', execute);
}
